import { Link } from "react-router-dom";
import { getHotDramas, formatPopularity } from "@/utils/content";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotSection() {
  const hot = getHotDramas(6);
  const rankColors = [
    "bg-primary-500 text-background-50",
    "bg-accent-500 text-accent-950",
    "bg-secondary-500 text-background-50",
  ];

  return (
    <section className="w-full bg-background-100 py-8 md:py-12">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          title="热门影视资源"
          subtitle="按照播放热度与讨论度实时更新"
          icon="ri-fire-line"
          moreTo="/category?sort=popular"
          moreLabel="更多热门"
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {hot.map((drama, index) => (
            <Link
              key={drama.id}
              to={`/detail/${drama.id}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-4 md:p-4"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold md:h-9 md:w-9 ${
                  index < 3 ? rankColors[index] : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-16">
                <img
                  src={drama.cover}
                  alt={`${drama.title} 封面`}
                  title={`${drama.title} 剧集介绍`}
                  className="h-full w-full object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600 md:text-base">
                    {drama.title}
                  </h3>
                  <span className="flex shrink-0 items-center gap-1 text-xs font-semibold text-accent-700">
                    <span className="flex h-3.5 w-3.5 items-center justify-center"><i className="ri-star-fill"></i></span>
                    {drama.rating}
                  </span>
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-1.5">
                  {drama.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <span className="flex h-3.5 w-3.5 items-center justify-center"><i className="ri-fire-line"></i></span>
                    热度 {formatPopularity(drama.popularity)}
                  </span>
                  <span className="hidden sm:inline">{drama.genre}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}